export const formatAmount = (num: number | string): string => {
    const numberValue = typeof num === 'string' ? parseFloat(num) : num;

    if (isNaN(numberValue)) return '0.00';

    return numberValue.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};